/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Steps } from 'antd';
import PayrollDetailSection from '../PayrollDetailSection';
import { APONTAMENTO } from '../../../services/apontamentoProducao';

const { Step } = Steps;

const StepsCustom = styled(Steps)`
  padding: 10px 20px;

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  .ant-steps-item-warning {
    .ant-steps-item-icon > .ant-steps-icon > .ant-steps-icon-dot {
      background-color: #faad14;
    }
    .ant-steps-item-content > .ant-steps-item-title,
    .ant-steps-item-description {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .step-tail-warning .ant-steps-item-tail::after {
    background: linear-gradient(
      to right,
      #00a89c 0%,
      /* green */ #00a89c 50%,
      #faad14 50%,
      /* orange */ #faad14 100%
    ) !important;
  }
`;

function PayrollStatus({ payroll }) {
  const faturadoEm = payroll.faturadoEm ? payroll.faturadoEm.format('DD/MM/YYYY HH:mm:ss') : null;
  const canShowPaidStep = new Date().toISOString().split('T')[0] >= process.env.REACT_APP_DATE_TO_SHOW_PAID_STATUS;

  const getIndexPositionByStatusNumber = () => {
    const { status } = payroll;
    const {
      enviada: ENVIADA,
      reabertura_pendente: REABERTURA_PENDENTE,
      reabertura_cancelada: REABERTURA_CANCELADA,
      processada: PROCESSADA,
      faturada: FATURADA,
      transmitida: TRANSMITIDA,
      transmitindo: TRANSMITINDO,
      pago: PAGO,
    } = APONTAMENTO.status;

    if ([ENVIADA, TRANSMITINDO, REABERTURA_PENDENTE, REABERTURA_CANCELADA].includes(status)) return 0;
    if (status === TRANSMITIDA) return 1;
    if (status === PROCESSADA) return 2;
    if (status === FATURADA) return 3;
    if (status === PAGO) return 4;
    return null;
  };

  const getLogTimeByStatus = (status) => {
    if (!payroll || !payroll.logs) return '';
    const [lastLog] = payroll.logs.filter((log) => log.tipoOperacao === status);
    if (!lastLog) return '';
    return lastLog.insercao.format('DD/MM/YYYY HH:mm:ss');
  };

  const getPaidStatus = () => {
    const { status } = payroll;
    if (status !== APONTAMENTO.status.pago) return '';
    return payroll.areAllCooperatorsPaid ? 'process' : 'warning';
  };

  return (
    <PayrollDetailSection title="Status do Processamento">
      <StepsCustom
        progressDot
        current={getIndexPositionByStatusNumber()}
      >
        <Step
          title="Enviada"
          description={getLogTimeByStatus('ENVIADA')}
        />
        <Step
          title="Transmitida"
          description={getLogTimeByStatus('TRANSMITIDO')}
        />
        <Step
          title="Processada"
          description={getLogTimeByStatus('PROCESSADA')}
        />
        <Step
          title="Fatura"
          description={faturadoEm}
          className={`step-tail-${getPaidStatus()}`}
        />
        {canShowPaidStep && (
          <Step
            title="Pago"
            status={getPaidStatus()}
            description={getLogTimeByStatus('PAGO')}
          />
        )}
      </StepsCustom>
    </PayrollDetailSection>
  );
}

PayrollStatus.propTypes = {
  payroll: PropTypes.shape({}).isRequired,
};

export default PayrollStatus;
